import { Component, NgZone } from '@angular/core';
import { RouterService } from '@shared/services/router.service';
import { SessionService } from '@shared/services/session.service';
import { firstValueFrom } from 'rxjs';
import { SetupStage } from '../../onboarding-web/containers/setup/setup.component';
import { OnboardingState } from '@local/client-contracts';
import { LinksService } from '@shared/services/links.service';
import { WalkthroughService } from '@shared/services/walkthrough.service';
import { ClientStorageService } from '@shared/services/client-storage.service';
import { TelemetryService } from '@shared/services';
import { FlagsService } from '@shared/services/testim-flags.service';
import { SessionStorageService } from '@shared/services/session-storage.service';
import { DeepPartial } from '@local/ts-infra';

declare global {
  interface Window {
    telemetryService: any;
  }
}

@Component({
  selector: 'testim',
  templateUrl: './testim.component.html',
  styleUrls: ['./testim.component.scss'],
})
export class TestimComponent {
  constructor(
    private sessionStorageService: SessionStorageService,
    private sessionService: SessionService,
    private linksService: LinksService,
    private walkthrough: WalkthroughService,
    private ngZone: NgZone,
    private routerService: RouterService,
    private clientStorage: ClientStorageService,
    private telemetryService: TelemetryService,
    private flagsService: FlagsService
  ) {
    (<any>window).testim = this;

    //expose the telemetry service for cypress through the window object.
    if (this.flagsService.isNotProd && !window.telemetryService) {
      window.telemetryService = this.telemetryService;
    }
  }

  public navigateByUrl(url: string) {
    this.ngZone.run(() => {
      this.routerService.navigateByUrl(url);
    });
  }

  public async changeOnBoardingState(stage: SetupStage) {
    const s = await firstValueFrom(this.sessionService.current$);
    if (!s) return;

    const onboardingStorage = this.sessionStorageService.getStore('roaming', 'account').entry<OnboardingState>('onboarding');

    let common: DeepPartial<OnboardingState> = {
      kyc: { completed: false },
      selectApps: { completed: false },
      connectApps: { completed: false, current: {}, apps: [] },
      completed: false,
    };

    switch (stage) {
      case 'kyc': {
        break;
      }
      case 'select-apps':
      case 'connect-apps': {
        common = { ...common, kyc: { completed: true } };
        break;
      }
      case 'done': {
        common = {
          ...common,
          kyc: { completed: true },
          selectApps: { completed: true },
          connectApps: { completed: true },
          completed: true,
        };
      }
    }

    await onboardingStorage.set(<OnboardingState>common);
  }
  public async signOut() {
    try {
      await this.sessionService.signOut(true);
    } catch (e) {
      console.error('Failed to signout', e);
    }
  }

  public async deleteAllLinks() {
    try {
      const allLinks = await firstValueFrom(this.linksService.all$);
      if (allLinks?.length) {
        allLinks.forEach((element) => {
          this.linksService.delete(element.id);
        });
      }
    } catch (e) {
      console.error('Failed to deleteAllLinks', e);
    }
  }

  public skipWalkthrough() {
    return this.walkthrough.skipAll(true);
  }
}
